import React from 'react';
import { Edit, SimpleForm, TextInput, required } from 'react-admin';

const DeliveryPartnerEdit = props => (
    <Edit {...props} redirect="list" undoable={false}>
        <SimpleForm variant="outlined">
            <TextInput source="name" validate={required()} />
        </SimpleForm>
    </Edit>
);

export default DeliveryPartnerEdit;
